import React, { useState } from "react";
import { ServerSideCustomPagination } from "../common/custom-pagination/server-side-custom-pagination";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

const permissionsKeyObj = {
  "Add New Role": PermissionList.admin_userAccess.add_role,
  "Add New User": PermissionList.admin_userAccess.add_user,
}

const UserSubHeader = ({
  addButtonTitle,
  Pagination,
  Sort,
  Export,
  onAddClick,
  stickyVal,
  classes,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      className={`main-body px-[30px] py-4 border-b table_border flex min-h-[76px] justify-between border-t 
        } ${classes ? classes : ""}`}
    >
      <div className="flex">

        <AllowedAccess permissions={[permissionsKeyObj[addButtonTitle]]}>
          <button
            onClick={() => {
              // navigate("/create-trial");
              onAddClick();
            }}
            onMouseEnter={() => {
              setHover(true);
            }}
            onMouseLeave={() => setHover(false)}
            className="flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[16px] font-mont font-[600] mr-[20px]"
          >
            <svg
              class="h-5 w-5 mr-2 text-white-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {" "}
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>{" "}
              <circle cx="8.5" cy="7" r="4"></circle>{" "}
              <line x1="20" y1="8" x2="20" y2="14"></line>{" "}
              <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
            {addButtonTitle}
          </button>
        </AllowedAccess>
        {Sort}
      </div>
      <div className="flex">
        {Pagination}
        {Export}
      </div>
    </div>
  );
};

export default UserSubHeader;
